export default function Header(){
    return (
        <header className="header" role="banner">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-5 col-sm-5 col-xs-5">
                        <div className="header__logo">
                            <a href="https://www.southglos.gov.uk" >
                                <img className="sgclogo" src="./assets/sgc-logo.svg" alt="SGC Logo" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}